import React, { Component } from "react";
import { ModalWithHeader } from "../shared/ui/Modal/Modal";
import styles from "./css/shareModal.module.css";
import { FacebookShareButton, LinkedinShareButton, PinterestShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { connect } from "react-redux";
import desc from "../../apps/Profile/pages/templates/desc";
// import Copy from './Image/DashboardImages/sharemodImages/copy.svg';
import { fixedEncodeURIComponent } from "../../redux/constants/commonFunctions";
import { withTranslation } from "react-i18next";

class ShareModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileLink: desc.website,
      showToast: false,
      toastMessage: "",
    };
  }
  getCourseUrl() {
    return window.location.href;
  }

  getProfileUrl() {
    const profileId = this.props.profile_id || "4";
    return `https://www.nxnearby.com/profile/${encodeURIComponent(profileId)}/view`;
  }

  showToastMessage = (message) => {
    this.setState({ toastMessage: message, showToast: true });
    setTimeout(() => {
      this.setState({ showToast: false, toastMessage: "" });
    }, 3000);
  };

  handleCopy = (toCopy) => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(toCopy)
        .then(() => this.showToastMessage("Link copied!"))
        .catch(() => this.showToastMessage("Copy failed"));
    } else {
      // Fallback copy
      const el = document.createElement("textarea");
      el.value = toCopy;
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy");
        this.showToastMessage("Link copied!");
      } catch (e) {
        this.showToastMessage("Copy failed");
      }
      document.body.removeChild(el);
    }
  };

  render() {
    const { showToast, toastMessage } = this.state;
    const isCourse = !!this.props.coursePage;
    const courseUrl = this.getCourseUrl();
    const profileUrl = this.getProfileUrl();

    // Short messages to use as title/quote
    const courseMessage = `Hello there — I'm inviting you to view this nxNearby course`;
    const profileMessage = `Hello there — I'm inviting you to view my nxNearby profile`;

    const pinterestMedia =
      this.props.image ||
      `${window.location.origin}/static/default-share-image.png` ||
      desc.website;

    return (
      <div>
        <ModalWithHeader
          title={this.props.t("common.share")}
          show={this.props.show}
          closeHandler={this.props.closeModal}
          maxWidth="569px"
          minWidth="350px"
        >
          <div className={styles.container}>
            <div style={{fontSize: "16px", fontWeight: "700", color: "#3f3f3f"}}>{this.props.t("modals.shareVia")}</div>
            <div className={styles.socialContainer}>

              <WhatsappShareButton
                url={isCourse ? courseUrl : profileUrl}
                title={isCourse ? courseMessage : profileMessage}
              >
                <img src="/Image/DashImage/whatsapp.png" height={45} width={45} alt="whatsapp" />
              </WhatsappShareButton>

              <FacebookShareButton
                url={isCourse ? courseUrl : profileUrl}
                quote={isCourse ? courseMessage : profileMessage}
              >
                <img src="/Image/DashImage/facebook.png" height={45} width={45} alt="facebook" />
              </FacebookShareButton>

              <TwitterShareButton
                url={isCourse ? courseUrl : profileUrl}
                title={isCourse ? courseMessage : profileMessage}
              >
                <img src="/Image/DashImage/twitter.png" height={45} width={45} alt="twitter" />
              </TwitterShareButton>

              <LinkedinShareButton
                url={isCourse ? courseUrl : profileUrl}
                title={isCourse ? courseMessage : profileMessage}
              >
                <img src="/Image/DashImage/linkedin.png" height={45} width={45} alt="linkedin" />
              </LinkedinShareButton>
              
              <PinterestShareButton
                media={pinterestMedia}
                url={isCourse ? courseUrl : profileUrl}
                description={isCourse ? courseMessage : profileMessage}>
                <img src="/Image/DashImage/pinterest.png" height={45} width={45}></img>
              </PinterestShareButton>

            </div>
            <div style={{ fontSize: "16px", fontWeight: "700", color: "#3f3f3f" }}>
              {this.props.t("modals.copyLink")}
            </div>

            <div className={styles.copyContainer}>
              <p className={styles.link}>
                {isCourse ? courseUrl : profileUrl}
              </p>

              <img
                onClick={() => this.handleCopy(isCourse ? courseUrl : profileUrl)}
                className={styles.copyButton}
                height="25px"
                width="25px"
                src="/Image/DashboardImages/sharemodImages/copy.svg"
                alt="copy link"
              />
            </div>
          </div>
        </ModalWithHeader>

        {/* Toast */}
        {showToast && (
          <div className={styles.toastCard}>
            <span>{toastMessage}</span>
            <span
              className={styles.closeIcon}
              onClick={() => this.setState({ showToast: false })}
            >
              &times;
            </span>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //U can destructure here to get only the required attributes from the state
  return {
    profile_id: state?.profile?.user?.profile_id || "4",
  };
};

export default withTranslation()(connect(mapStateToProps, null)(ShareModal));

// import {
//   FacebookShareButton,
//   LinkedinShareButton,
//   PinterestShareButton,
//   TwitterShareButton,
//   WhatsappShareButton,
// } from "react-share";
// import { ModalWithHeader } from "../shared/ui/Modal/Modal";
// import styles from "./css/shareModal.module.css";
// // import Copy from './Image/DashboardImages/sharemodImages/copy.svg';

// export default class ShareModal extends Component {
//   render() {
//     return (
//       <div>
//         <ModalWithHeader
//           title="Share"
//           show={this.props.show}
//           closeHandler={this.props.closeModal}
//         // closeModal={this.props.closeModal}
//           maxWidth="569px"
//         >
//           <div className={styles.container}>
//             <div className={styles.socialContainer}>
//               <WhatsappShareButton
//                 url={`https://chalkmates.com/post/${this.props.link}`}
//                 quote="I have published this awesome post on chalkmates"
//               >
//                 <img src="/Image/DashImage/whatsapp.png"></img>
//               </WhatsappShareButton>
//               <FacebookShareButton
//                 url={`https://chalkmates.com/post/${this.props.link}`}
//                 quote="I have published this awesome post on chalkmates"
//               >
//                 <img src="/Image/DashImage/facebook.png"></img>
//               </FacebookShareButton>
//               <TwitterShareButton
//                 url={`https://chalkmates.com/post/${this.props.link}`}
//                 quote="I have published this awesome post on chalkmates"
//               >
//                 <img src="/Image/DashImage/twitter.png"></img>
//               </TwitterShareButton>
//               <LinkedinShareButton
//                 url={`https://chalkmates.com/post/${this.props.link}`}
//                 quote="I have published this awesome post on chalkmates"
//               >
//                 <img src="/Image/DashImage/linkedin.png"></img>
//               </LinkedinShareButton>
//               <PinterestShareButton
//                 url={`https://chalkmates.com/post/${this.props.link}`}
//                 quote="I have published this awesome post on chalkmates"
//               >
//                 <img src="/Image/DashImage/pinterest.png"></img>
//               </PinterestShareButton>
//             </div>
//             <div className={styles.copyContainer}>
//               <p className={styles.link}>
//                 https://chalkmates.com/post/{this.props.link}
//               </p>
//               <img
//                 onClick={() => {
//                   navigator.clipboard.writeText(
//                     `https://chalkmates.com/post/${this.props.link}`
//                   );
//                 }}
//                 className={styles.copyButton}
//                 height="25px"
//                 width="25px"
//                 src="/Image/DashboardImages/sharemodImages/copy.svg"
//               />
//             </div>
//           </div>
//         </ModalWithHeader>
//       </div>
//     );
//   }
// }
